import {Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {DayBindingtypeModel, DayBindingValueModel} from './day-bindingtype.model';

@Component({
  selector: 'app-day-bindingtype-edit',
  templateUrl: './day-bindingtype-edit.component.html',
  styleUrls: ['./day-bindingtype-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DayBindingtypeEditComponent  implements OnInit, OnChanges {

  @Input() dayBindingValue: DayBindingValueModel;
  @Input() readonly = false;
  @Output() changeDayBindingValue = new EventEmitter<DayBindingValueModel>();

  public readonly labels: DayBindingtypeModel[] = [{
    label: 'Sunrise',
    value: 'start'
  }, {
    label: 'Sunset',
    value: 'end'
  }
  ];
  public  current = this.labels.find(label => label.value === this.dayBindingValue) || this.labels[0];
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.current = this.labels.find(label => label.value === this.dayBindingValue) || this.labels[0];
  }

  onChange(label: DayBindingtypeModel): void {
    this.current = label;
    this.changeDayBindingValue.emit(this.current.value);
  }

}
